module.exports = __webpack_public_path__ + "img/face-grin-tongue-squint.e55a5562.svg";